import React from "react";
import classNames from "classnames";
import { currencyFormatterNoFractions } from "@common/helpers/currency";
import { ENTITY_TRANSACTIONS_THRESHOLD } from "@common/flatRateBilling";
import styles from "./FlatRateBilling.module.scss";

interface Props {
    isOnFreePlan: boolean;
    isAtOrOverLimit: boolean;
    maxUsage: number;
    /**
     * True when the workspace is on a catalog version that enforces the
     * 250-transaction free-tier threshold (V2 metered or V3 licensed).
     * V1 customers see the legacy "$X business expense" framing instead.
     */
    isThresholdEnforcedPlan?: boolean;
    isAtTransactionLimit?: boolean;
}

export const CurrentPlanFooter: React.FC<Props> = ({
    isAtOrOverLimit,
    maxUsage,
    isOnFreePlan,
    isThresholdEnforcedPlan,
    isAtTransactionLimit,
}) => {
    if (isOnFreePlan) {
        if (isThresholdEnforcedPlan) {
            if (isAtTransactionLimit) {
                return (
                    <footer
                        className={classNames(
                            styles.section,
                            styles.footer,
                            styles.warning,
                        )}
                    >
                        You've hit the{" "}
                        <strong>
                            {ENTITY_TRANSACTIONS_THRESHOLD} transaction
                        </strong>{" "}
                        limit on the free plan. <br />
                        Upgrade now to continue using Kick.
                    </footer>
                );
            } else {
                return (
                    <footer
                        className={classNames(styles.section, styles.footer)}
                    >
                        Once you reach {ENTITY_TRANSACTIONS_THRESHOLD}{" "}
                        transactions, you will be required to upgrade to a paid
                        tier, or have limited access to Kick.
                    </footer>
                );
            }
        }

        if (isAtOrOverLimit) {
            return (
                <footer
                    className={classNames(
                        styles.section,
                        styles.footer,
                        styles.warning,
                    )}
                >
                    You've hit the{" "}
                    <strong>
                        {currencyFormatterNoFractions.format(maxUsage)}
                    </strong>{" "}
                    free business expense limit. <br />
                    Upgrade now to continue using Kick.
                </footer>
            );
        } else {
            return (
                <footer className={classNames(styles.section, styles.footer)}>
                    Once you hit the limit above, you will be required to
                    upgrade to a paid tier, or have limited access to Kick.
                </footer>
            );
        }
    }

    return null;
};
